import type { Citation } from '@/types/chat';

export type CitationTarget =
  | { kind: 'document'; documentId: string }
  | { kind: 'historyRow'; historyRowId: string; matterId: string };

/**
 * What clicking a citation opens: a document, or the details of a history row with no file. Returns
 * nothing when there's no matter for a row citation, or no id at all (still streaming).
 */
export function resolveCitationTarget(
  citation: Citation | undefined | null,
  matterId: string | undefined,
): CitationTarget | null {
  if (!citation) return null;
  if (citation.documentId) return { kind: 'document', documentId: citation.documentId };
  if (citation.historyRowId && matterId) {
    return { kind: 'historyRow', historyRowId: citation.historyRowId, matterId };
  }
  return null;
}

/** The history row a cited document belongs to, from any citation of that document. */
export function getCitedDocumentHistoryRowId(citations: Record<string, Citation>, documentId: string): string | null {
  for (const citation of Object.values(citations)) {
    if (citation.documentId === documentId && citation.historyRowId) return citation.historyRowId;
  }
  return null;
}
